/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { fetchInvitations } from './invitations.thunk';

/* Initial state */
const initialState = {
  invitationsData: {
    status: ThunkStatus.IDLE,
    page: {},
    rowItems: [],
  },
};

/* Slice */
export const invitationsSlice = createSlice({
  name: 'invitations',
  initialState,
  reducers: {
    invitationUpdate(state, action) {
      const updatedInvitation = action.payload;

      state.invitationsData.rowItems = state.invitationsData.rowItems.map(invitationRow =>
        invitationRow.id === updatedInvitation.id ? updatedInvitation : invitationRow,
      );
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchInvitations.pending, (state) => {
        state.invitationsData.status = ThunkStatus.LOADING;
      })
      .addCase(fetchInvitations.fulfilled, (state, action) => {
        state.invitationsData.status = ThunkStatus.SUCCEEDED;
        state.invitationsData.rowItems = action.payload.invitationsPage.content;
        state.invitationsData.page.totalElements = action.payload.invitationsPage.totalElements;
        state.invitationsData.page.totalPages = action.payload.invitationsPage.totalPages;
      })
      .addCase(fetchInvitations.rejected, (state) => {
        state.invitationsData.status = ThunkStatus.FAILED;
        state.invitationsData.rowItems = [];
      });
  },
});

/* Selectors */
const selectInvitations = state => state[invitationsSlice.name];
export const selectStatus = createSelector(selectInvitations, ({ invitationsData }) => invitationsData.status);
export const selectInvitationsData = createSelector(selectInvitations, ({ invitationsData }) => invitationsData);
export const selectInvitationsRows = createSelector(selectInvitationsData, ({ rowItems }) => rowItems);

/* Actions */
export const { invitationUpdate } = invitationsSlice.actions;
